import Shelf from "./shelf/shelf.component";
import PricingAvailability, {
  AvailabilityOption,
} from "./pricingAvailability/PricingAvailability";
import PricingSection from "./PricingSection/PricingSection";
import AvailabilitySection from "./AvailabilitySection/AvailabilitySection";
import Message from "./Message/Message";
import { ProductStatusText } from "./productStatus/ProductStatusText";
import Link from "./link/Link";
import PdpLink from "./pdpLink/PdpLink";
import { LeadTimeSection } from "./AvailabilitySection/AvailabilitySection";

interface InventoryResultsPricingAndAvailibilityProps {
  isProductDiscontinued: boolean;
  ProductNumber: string;
  ProductStatus: any[];
  ReplacementProductText: string | null;
  ReplacementProductUrl: string | null;
  InventoryStatusMessage: string;
}

const InventoryResultsPricingAndAvailibility = ({
  ProductStatus,
  isProductDiscontinued,
  ReplacementProductUrl,
  ReplacementProductText,
  InventoryStatusMessage,
}: InventoryResultsPricingAndAvailibilityProps) => {
  // to prevent the chevron icon from breaking onto a new line by itself on small screens
  // we're wrapping the chevron and the last word of the text in their own span so they
  // will break onto a new line together
  const renderReplacementProductLinkText = () => {
    const wordsArray = ReplacementProductText?.split(" ") ?? [];
    const lastWord = wordsArray.pop();

    return (
      <>
        {wordsArray.join(" ") + " "}
        <span>
          {lastWord}
          <span className="material-icons">chevron_right</span>
        </span>
      </>
    );
  };

  return isProductDiscontinued ? (
    <Shelf mobile="20" tablet="25" desktop="25">
      {" "}
      <div className="pricingAvailability_linkAndLeadTime">
        <PricingAvailability
          availabilityOption={AvailabilityOption.Discontinued}
        >
          <Message
            text={InventoryStatusMessage}
            additionalClass="pricingAvailability_messageSpacing"
          />
          {ReplacementProductUrl && ReplacementProductText && (
            <Link
              link={ReplacementProductUrl}
              className="pricingAvailability_replacementLink"
            >
              <>{renderReplacementProductLinkText()}</>
            </Link>
          )}
        </PricingAvailability>
        <LeadTimeSection />
      </div>
    </Shelf>
  ) : (
    <>
      {ProductStatus[0]?.ProductStatus === "Coming Soon" && (
        <ProductStatusText
          mainText={`${ProductStatus[0].ProductStatus.toUpperCase()}!`}
          mainTextColor={"green"}
        />
      )}
      <PdpLink />
      <Shelf mobile="20" tablet="25" desktop="25">
        <PricingAvailability availabilityOption={AvailabilityOption.Pricing}>
          <PricingSection />
        </PricingAvailability>
      </Shelf>
      <Shelf mobile="20" tablet="25" desktop="25">
        <PricingAvailability
          availabilityOption={AvailabilityOption.Availability}
        >
          <AvailabilitySection />
        </PricingAvailability>
      </Shelf>
    </>
  );
};

export default InventoryResultsPricingAndAvailibility;
